import { ChainId } from '@decent.xyz/box-common';
import { isProductionEnv } from '../../../../config';

type TGetZoraMintPageUrl = {
  contractAddress: string;
  tokenId: string;
  chainId: ChainId;
};

export const getTransactionExplorerUrl = ({ contractAddress, tokenId }: TGetZoraMintPageUrl) =>
  isProductionEnv
    ? `https://explorer.zora.energy/token/${contractAddress}/instance/${tokenId}`
    : `https://sepolia.basescan.org/token/${contractAddress}?a=${tokenId}`;
